import { baseURL } from '../components/config';

export const URI = {
  register: `${baseURL}/api/auth/register`,
  login: `${baseURL}/api/auth/login`,
  me: `${baseURL}/api/auth/me`,
  forgot_password: `${baseURL}/api/auth/forgot-password`,
  reset_password: `${baseURL}/api/auth/reset-password`,
  add_user: `${baseURL}/api/auth/add-user`,
  users: `${baseURL}/api/user/users`,
  user: `${baseURL}/api/user/user`,
  add_restaurant: `${baseURL}/api/restaurant/add`,
  restaurants: `${baseURL}/api/restaurant/restaurants`,
  restaurants_analytics: `${baseURL}/api/restaurant/restaurants/analytics`,
  manager_restaurants_analytics: `${baseURL}/api/restaurant/restaurants/manager/analytics`,
  restaurant: `${baseURL}/api/restaurant/restaurant`,
  restaurants_user: `${baseURL}/api/user/add-restaurants-user`,
  restaurant_user_by_id: (restaurantId) => `${baseURL}/api/user/restaurant/${restaurantId}`,
  add_users_restaurant: `${baseURL}/api/user/add-users-restaurant`,
  delete_user_restaurant: `${baseURL}/api/user/restaurant/user`,
  restaurant_tasks: `${baseURL}/api/task/restaurant-tasks`,
  tasks_by_id: (id) => `${baseURL}/api/task/restaurant-tasks/${id}`,
  tasks_activities_by_id: (id) => `${baseURL}/api/task/restaurant-tasks/${id}/activities`,
  tasks_progress_by_id: (id) => `${baseURL}/api/task/restaurant-tasks/progress/${id}`,
  task_move_copy: (id) => `${baseURL}/api/task/restaurant-tasks/${id}/move-copy`,
  label: `${baseURL}/api/label/label`,
  label_by_id: (id) => `${baseURL}/api/label/label/${id}`,
  task_comments: (taskId) => `${baseURL}/api/task/restaurant-tasks/${taskId}/comments`,
  comment_by_id: (id) => `${baseURL}/api/task/restaurant-tasks/comments/${id}`,

  // Emails
  user_creds: `${baseURL}/api/email/user-creds`,
  new_account: `${baseURL}/api/email/new-account`,
  account_approved: `${baseURL}/api/email/account-approved`,
  password_changed: `${baseURL}/api/email/password-changed`,
  reset_password_email: `${baseURL}/api/email/reset-password`,
  store_assigned: `${baseURL}/api/email/store-assigned`,
  task_assigned: `${baseURL}/api/email/task-assigned`,
  task_completed: `${baseURL}/api/email/task-completed`,
  undo_task: `${baseURL}/api/email/undo-task`,
  task_overdue: `${baseURL}/api/email/task-overdue`,
};
